<template>
  <div class="sticky top-0 z-10 bg-white border-b border-gray-200 shadow-sm w-full pb-4">
    <div class="w-full">
      <!-- Filters Section -->
      <div class="w-full">
        <filters
          :showCallType="filterConfig.hasCallType"
          :showAgent="filterConfig.hasAgents"
          :showAgentStatus="filterConfig.hasAgentStatus"
          :showHungparty="filterConfig.hasHungparty"
          :showNumber="filterConfig.hasNumber"
          :showDuration="filterConfig.hasDuration"
          :showSkill="filterConfig.hasSkill"
          :showPeriods="filterConfig.hasPeriod"
          :hideExport="filterConfig.isNotExport"
          :showOmni="filterConfig.hasOmni"
          :showReportVariant="filterConfig.hasReportVariant"
          :useSingleDayDatePicker="filterConfig.useSingleDayDatePicker"
          :skills="skills"
          :agents="agents"
          @report_type="handleReportTypeChange"
          @submitReport="handleFilterSubmit"
          @skillChanged="handleSkillChanged"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Filters from './Filters.vue';

export default {
  name: 'ReportHeader',
  components: {
    Filters
  },
  props: {
    filterConfig: {
      type: Object,
      required: true
    },
    skills: {
      type: Array,
      default: () => []
    },
    agents: {
      type: Array,
      default: () => []
    }
  },
  emits: [
    'report-type-change',
    'filter-submit',
    'skill-changed'
  ],
  methods: {
    handleReportTypeChange(reportType) {
      this.$emit('report-type-change', reportType);
    },
    
    handleFilterSubmit(filters) {
      this.$emit('filter-submit', filters);
    },
    
    handleSkillChanged(skill) {
      this.$emit('skill-changed', skill);
    }
  }
};
</script>

<style scoped>
/* Sticky positioning for the header */
.sticky {
  position: sticky;
  top: 0;
  z-index: 10;
}
</style> 